import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef
} from '@angular/core';

import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { HotelFilterProvider } from '@shared/hotel-itinerary/hotel-filters';

@Component({
  selector: 'app-hotel-filter-bar',
  templateUrl: './hotel-filter-bar.container.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HotelFilterBarContainer {

  @Input() isHotelByPackage: boolean;
  @Input() viewType: HotelFilterProvider;
  @Input() isSticky: boolean;
  @Input() hourType: string[];

  @Output() viewFilters: EventEmitter<void> = new EventEmitter<void>();

  public filtersHaveBeenApplicated = false;

  public readonly icons = Icon;

  constructor(
    private readonly cdr: ChangeDetectorRef,
  ) {}

  public filtersHaveBeenApplicatedAction(value: boolean): void {
    this.filtersHaveBeenApplicated = value;
    this.cdr.detectChanges();
  }

}
